export default __webpack_public_path__ + "static/media/blow-soft-two.1a6bf913.wav";